import { Injectable } from "@angular/core";
import {
  Router,
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { OrderDetailsService } from "src/app/Services/ShoppingService/OrderService/order-details.service";
import { IOrderResponse } from "src/app/Models/Interface/Order/EditOrder/order-resoponse";

@Injectable({
  providedIn: "root",
})
export class OrderDetailsResolver implements Resolve<IOrderResponse> {
  constructor(private orderDetailsService: OrderDetailsService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IOrderResponse> {
    let orderId = Number(route.paramMap.get("orderId"));
    return this.orderDetailsService.getOrderById(orderId);
  }
}
